import { find, get, isEmpty } from "lodash";
import moment from "moment";
import { MdClose } from "react-icons/md";
import {
  CONTACT_POINT_SYSTEM,
  DATE_FORMAT,
  TEMPLATE_TYPES,
  TEMPLATES,
} from "utils/constants";
import Header from "../../../../Header";

function View({ contact, updateProjectStatus, onClose, locked }) {
  const firstname = get(contact, "user.firstname", "");
  const lastname = get(contact, "user.lastname", "");
  const displayName = `${firstname} ${lastname}`.trim();

  const birthDate = get(contact, "user.birthDate");
  const formattedBirthDate = birthDate
    ? moment(birthDate).format("DD/MM/YYYY")
    : "";

  const phone = get(
    find(get(contact, "telecoms", []), {
      system: CONTACT_POINT_SYSTEM.PHONE,
    }),
    "value",
    "",
  );

  const email = get(
    find(get(contact, "telecoms", []), {
      system: CONTACT_POINT_SYSTEM.EMAIL,
    }),
    "value",
    "",
  );

  const handleEdit = () => {
    updateProjectStatus({
      template:
        TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_MUTUAL_MOBILITY].ADHERENT_INFO,
      isBeforeLocked: true,
    });
  };

  return (
    <div className="miltis-profile-modal__wrapper">
      <div className="miltis-profile-modal__header">
        <h2 className="miltis-profile-modal__header--title">
          Vos informations
        </h2>
      </div>
      <div className="miltis-profile-modal__content">
        <div className="miltis-profile-modal__section">
          <div className="miltis-profile-modal__edit-wrapper">
            <button
              className="miltis-profile-modal__edit"
              onClick={handleEdit}
              type="button"
            >
              Modifier
            </button>
          </div>
          <div className="miltis-profile-modal__info-list">
            <div className="miltis-profile-modal__info-item">
              <span className="miltis-profile-modal__info-label">
                Vous êtes{" "}
              </span>
              <span className="miltis-profile-modal__info-value">
                {displayName}
              </span>
            </div>
            {formattedBirthDate && (
              <div className="miltis-profile-modal__info-item">
                <span className="miltis-profile-modal__info-label">
                  Date de naissance
                </span>
                <span className="miltis-profile-modal__info-value">
                  {formattedBirthDate}
                </span>
              </div>
            )}
            {phone && (
              <div className="miltis-profile-modal__info-item">
                <span className="miltis-profile-modal__info-label">
                  N° de téléphone
                </span>
                <span className="miltis-profile-modal__info-value">
                  {phone}
                </span>
              </div>
            )}
            {email && (
              <div className="miltis-profile-modal__info-item">
                <span className="miltis-profile-modal__info-label">
                  Adresse email
                </span>
                <span className="miltis-profile-modal__info-value">
                  {email}
                </span>
              </div>
            )}
          </div>
        </div>
        <button
          className="miltis-profile-modal__close"
          onClick={onClose}
          type="button"
        >
          <MdClose size={24} />
          <span>Fermer</span>
        </button>
      </div>
    </div>
  );
}

export default View;
